module.exports = __webpack_public_path__ + "static/react-themes-spectral-56bbb76e88e07ee1044f61f66bcbd919.jpg";